import React from "react";
import "./ServiceLevelAgreementPage.css";

const ServiceLevelAgreementPage = () => {

  const exportPDF = () => {
    window.print();
  };


  return (
    <div className="sla-container">

      <div className="sla-actions">
        <button onClick={exportPDF}>
          🖨 Print / Export PDF
        </button>
      </div>


      <header className="sla-header">
        <h1>Service Level Agreement (SLA)</h1>

        <p>
          Effective Date: July 29, 2026
        </p>

        <p>
          This Service Level Agreement defines the service commitments,
          availability targets, support standards, and responsibilities
          between Magyne and its customers.
        </p>

      </header>



      <section>
        <h2>1. Introduction</h2>

        <p>
          Magyne provides cloud-based Enterprise Resource Planning (ERP)
          solutions designed to help organizations manage their operations
          efficiently. This SLA outlines the expected service performance
          levels and support commitments provided by Magyne.
        </p>

      </section>



      <section>

        <h2>2. Service Availability Commitment</h2>

        <p>
          Magyne targets the following monthly service availability:
        </p>


        <table>

          <thead>
            <tr>
              <th>Service</th>
              <th>Availability Target</th>
            </tr>
          </thead>

          <tbody>

            <tr>
              <td>Core ERP Applications</td>
              <td>99.5%</td>
            </tr>

            <tr>
              <td>Authentication Services</td>
              <td>99.9%</td>
            </tr>

            <tr>
              <td>Database Services</td>
              <td>99.5%</td>
            </tr>

          </tbody>

        </table>


      </section>



      <section>

        <h2>3. Planned Maintenance</h2>

        <p>
          Magyne may perform scheduled maintenance to improve reliability,
          security, and performance.
        </p>

        <ul>

          <li>
            Customers will receive advance notification where possible.
          </li>

          <li>
            Maintenance will normally occur during low-usage periods.
          </li>

          <li>
            Emergency maintenance may occur without prior notice.
          </li>

        </ul>

      </section>




      <section>

        <h2>4. Support Services</h2>


        <table>

          <thead>

            <tr>
              <th>Priority</th>
              <th>Description</th>
              <th>Response Time</th>
            </tr>

          </thead>


          <tbody>

            <tr>
              <td>P1 - Critical</td>

              <td>
                Complete system outage affecting business operations.
              </td>

              <td>
                Within 1 hour
              </td>

            </tr>


            <tr>

              <td>
                P2 - High
              </td>

              <td>
                Major functionality unavailable.
              </td>

              <td>
                Within 4 hours
              </td>

            </tr>


            <tr>

              <td>
                P3 - Medium
              </td>

              <td>
                Limited functionality issue.
              </td>

              <td>
                Within 1 business day
              </td>

            </tr>


            <tr>

              <td>
                P4 - Low
              </td>

              <td>
                General questions and improvements.
              </td>

              <td>
                Within 3 business days
              </td>

            </tr>


          </tbody>


        </table>


      </section>





      <section>

        <h2>5. Data Protection and Security</h2>


        <p>
          Magyne maintains security practices designed to protect customer
          information including:
        </p>


        <ul>

          <li>
            Encrypted communication using HTTPS/TLS.
          </li>

          <li>
            Tenant data isolation.
          </li>

          <li>
            Role-based access control.
          </li>

          <li>
            Secure authentication mechanisms.
          </li>

          <li>
            Regular system monitoring.
          </li>

        </ul>


      </section>





      <section>

        <h2>6. Backup and Recovery</h2>


        <p>
          Magyne maintains backup procedures to support disaster recovery
          and business continuity.
        </p>


        <ul>

          <li>
            Automated database backups.
          </li>

          <li>
            Backup integrity monitoring.
          </li>

          <li>
            Recovery procedures for service interruptions.
          </li>

        </ul>


      </section>





      <section>

        <h2>7. Customer Responsibilities</h2>


        <p>
          Customers agree to:
        </p>


        <ul>

          <li>
            Maintain secure account credentials.
          </li>

          <li>
            Provide accurate business information.
          </li>

          <li>
            Ensure authorized usage of the platform.
          </li>

          <li>
            Report incidents promptly.
          </li>

        </ul>


      </section>





      <section>

        <h2>8. SLA Exclusions</h2>


        <p>
          The SLA does not cover interruptions caused by:
        </p>


        <ul>

          <li>
            Customer misuse of the system.
          </li>

          <li>
            Internet service provider failures.
          </li>

          <li>
            Third-party service outages.
          </li>

          <li>
            Force majeure events.
          </li>

        </ul>


      </section>





      <section>

        <h2>9. Service Improvement</h2>


        <p>
          Magyne continuously improves its infrastructure, security,
          and software capabilities to provide reliable business solutions.
        </p>


      </section>





      <footer className="sla-footer">

        <p>
          © {new Date().getFullYear()} Magyne. All rights reserved.
        </p>

      </footer>



    </div>
  );
};


export default ServiceLevelAgreementPage;